import List from '@/components/list';
// import { ShareQrCodeModal } from '@/components/qr-code';
import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import { useShareQrCodeModal } from '@/components/qr-code/share-qr-code-modal/useShareQrCodeModal';
import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import LinkIcon from '../../images/link.svg?react';
import ScanIcon from '../../images/scan.svg?react';

export const GroupShareLink = ({
  chat,
  members,
}: {
  chat: Chat;
  members?: ChatGroupMember[];
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const { setOpen, copyShareLink, shareLink, shareQrCodeModal, groupShareLink } =
    useShareQrCodeModal({
      messageApi,
      apiParam: {
        group_id: chat.chat_id,
      },
    });

  const shortName = useMemo(() => {
    return shareLink?.split('/').pop() ?? '';
  }, [shareLink]);

  const qrCodeUrl = useMemo(() => {
    if (shareLink) {
      const url_ = new URL(shareLink);
      return url_.host.slice(0, 30) + '/...' + shortName;
    }
    return '';
  }, [shareLink, shortName]);

  useEffect(() => {
    groupShareLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <List
        title="Share link"
        desc={qrCodeUrl}
        descLink
        icon={<LinkIcon />}
        operationIcon={
          <ScanIcon
            onClick={(e) => {
              e.stopPropagation();
              setOpen(true);
            }}
          />
        }
        onClick={() => copyShareLink()}
        // onDoubleClick={() => copyShareLink()}
      />
      {contextHolder}
      {shareQrCodeModal({
        headerAvatar: chat.avatar ?? '',
        headerName: chat.name ?? '',
        shortName,
        members,
      })}
    </>
  );
};
